import * as React from 'react';
import { HTMLAttributes } from 'react';
import * as cs from 'classnames';
import './Hyperlink.css';

export interface HyperlinkProps {
    uri: string;
    title: string;
    target?: string;
}

export const Hyperlink: React.FC<HyperlinkProps & HTMLAttributes<HTMLElement>> =
    ({ uri, title, className, target = '_blank' }) => (
        <a
            className={cs('asset', 'asset-hyperlink', className)}
            href={uri}
            target={target}
        >
            {title}
        </a>
    );


// WEBPACK FOOTER //
// ./src/asset/Hyperlink.tsx